import { Configuration } from 'src/app/models/configurators-2d/applications/closet-doors-custom/configuration/configuration';
import { ClosetDoorsCustomService } from 'src/app/services/configurators-2d/applications/closet-doors-custom.service';
import { ConfiguratorItem } from '../configurator-item';

export abstract class ClosetDoorsCustomConfiguratorItem extends ConfiguratorItem<
  Configuration,
  ClosetDoorsCustomService
> {
  constructor(closetDoorsCustomService: ClosetDoorsCustomService) {
    super(closetDoorsCustomService);
  }
}
